var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu" }, [
    _c("div", { staticClass: "menu-header" }, [
      _vm.level > 0
        ? _c("a", {
            staticClass: "back",
            domProps: { innerHTML: _vm._s(_vm.backIcon) },
            on: { click: _vm.back },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "menu-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.activeItem ? _vm.activeItem.title : "Menu") +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("a", {
        staticClass: "close",
        domProps: { innerHTML: _vm._s(_vm.closeIcon) },
        on: { click: _vm.close },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content limit" },
      [
        _c(
          "transition",
          { attrs: { name: `items-${_vm.dir}`, mode: "out-in" } },
          [
            _c("div", { key: _vm.level }, [
              _c(
                "div",
                { staticClass: "items" },
                _vm._l(_vm.currentItems, function (item) {
                  return _c(
                    "div",
                    { key: item.title, staticClass: "menu-item" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "item",
                          attrs: { href: item.url },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.click(item)
                            },
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "title",
                            class: { normal: _vm.level == 2 },
                            domProps: { textContent: _vm._s(item.title) },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.level === 0 && _vm.shops[0]
                ? _c("div", [
                    _c(
                      "select",
                      {
                        staticClass: "country_code",
                        attrs: { onchange: "window.location = this.value" },
                      },
                      _vm._l(_vm.shops, function (shop, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: shop.url } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(shop.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }